import styled from "styled-components"

const Paragraph = styled.p`
  font-size: clamp(0.7rem, 0.1rem + 1vw, 1.2rem);
  color: ${props => (props.color ? props.color : props.theme.color.black)};
  line-height: 1.94;
`

export { Paragraph }
